import { Helper } from "../helpers/helper";
import { ChangeLogProperties } from "../models/changeLog.models";
import { ChangeLogItem, ImisResponseItems } from "../models/imis.models";
import { RestUtility } from "./rest.utility";

/**
 * Static helper for querying iMIS change log records via the /api/changelog REST endpoint.
 */
export class ChangeLogUtility {
    public static readonly REQUEST_URL = "/api/changelog";

    /**
     * Retrieves change log records matching the given filter properties, ordered by change date.
     * @param properties Filter/sort criteria for the query (object type, property name, ordinal, change date range, record ID, limit, and ascending/descending order); defaults to an empty filter when omitted.
     * @param rawResponse Optional flag to request the raw (unparsed) REST response instead of the parsed data.
     * @returns The matching change log items; a single page (up to the given limit) if a limit is specified, otherwise all matching records.
     */
    public static getChangeLogRecords(properties: ChangeLogProperties, rawResponse?: boolean): Promise<ImisResponseItems<ChangeLogItem>> {
        let parameterProperties: ChangeLogProperties = properties || {};
        let requestProperties = {
            objectTypeName: parameterProperties.objectTypeName,
            propertyName: parameterProperties.propertyName,
            ordinal: parameterProperties.ordinal,
            limit: parameterProperties.limit,
            orderBy: "ChangeDate:" + (parameterProperties.orderByLeastRecent ? "ascending" : "descending")
        };

        if (!Helper.isArrayNullOrEmpty(parameterProperties.changeDate)) {
            let lowChangeDate = parameterProperties.changeDate[0];
            let highChangeDate = lowChangeDate;
            if (parameterProperties.changeDate.length > 1) {
                highChangeDate = parameterProperties.changeDate[1];
            }

            let lowChangeDateString = Helper.getDateTimeString(lowChangeDate);
            let highChangeDateString = Helper.getDateTimeString(highChangeDate);

            requestProperties["changeDate"] = [`ge:${lowChangeDateString}`, `le:${highChangeDateString}`]
        }

        if (!Helper.isStringNullOrEmpty(parameterProperties.id)) {
            requestProperties["Identity.IdentityElement"] = parameterProperties.id;
        }

        let responseData = null;
        if (parameterProperties.limit != null) {
            responseData = RestUtility.restApiGetData(this.REQUEST_URL, requestProperties, rawResponse);
        } else {
            responseData = RestUtility.restApiGetDataAll(this.REQUEST_URL, requestProperties, rawResponse);
        }

        return responseData;
    }
} 